import { ShowSnackbar } from './../../shared/shared.actions'
import {
  FetchUsersSuccess,
  FetchUsersFailure,
  FetchUsersRequest,
  DeleteUserRequest,
  DeleteUserSuccess,
  DeleteUserFailure,
  FetchRolesRequest,
  FetchRolesSuccess,
  FetchRolesFailure,
  CreateUserRequest,
  CreateUserSuccess,
  CreateUserFailure,
  FetchUserSuccess,
  FetchUserFailure,
  FetchUserRequest,
  UpdateUserRequest,
  UpdateUserSuccess,
  UpdateUserFailure,
  UpdateUserPasswordRequest,
  UpdateUserPasswordSuccess,
  UpdateUserPasswordFailure,
} from './users.actions'
import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import * as UsersTypes from './users.types'

import { map, switchMap, tap, catchError } from 'rxjs/operators'
import { Router } from '@angular/router'
import { UsersService } from './users.service'

@Injectable()
export class UsersEffects {
  constructor(
    private actions: Actions,
    private usersService: UsersService,
    private router: Router,
  ) {}

  FetchUsers$ = createEffect(() =>
    this.actions.pipe(
      ofType(UsersTypes.FETCH_USERS_REQUEST),
      switchMap((action: FetchUsersRequest) => {
        return this.usersService.fetchUsers(action.payload).pipe(
          map((result) => {
            return new FetchUsersSuccess(
              result.data.results,
              result.data.totalCount,
              result.data.filteredCount,
            )
          }),
          catchError((err, caught) => {
            console.log(err)
            return of(new FetchUsersFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  FetchUser$ = createEffect(() =>
    this.actions.pipe(
      ofType(UsersTypes.FETCH_USER_REQUEST),
      switchMap((action: FetchUserRequest) => {
        return this.usersService.fetchUser(action.id).pipe(
          map((result) => {
            return new FetchUserSuccess(result.data, action.property)
          }),
          catchError((err, caught) => {
            return of(new FetchUserFailure({ error: err }, action.property))
          }),
        )
      }),
    ),
  )

  FetchRoles$ = createEffect(() =>
    this.actions.pipe(
      ofType(UsersTypes.FETCH_ROLES_REQUEST),
      switchMap(() => {
        return this.usersService.fetchRoles().pipe(
          map((result) => {
            return new FetchRolesSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchRolesFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  DeleteUser$ = createEffect(() =>
    this.actions.pipe(
      ofType(UsersTypes.DELETE_USER_REQUEST),
      switchMap((action: DeleteUserRequest) => {
        return this.usersService.deleteUser(action.id).pipe(
          switchMap((result) => {
            return [new DeleteUserSuccess()]
          }),
          catchError((err, caught) => {
            return of(new DeleteUserFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  CreateUser$ = createEffect(() =>
    this.actions.pipe(
      ofType(UsersTypes.CREATE_USER_REQUEST),
      switchMap((action: CreateUserRequest) => {
        return this.usersService.createUser(action.payload).pipe(
          switchMap((result) => {
            this.router.navigate(['/admin/users'])
            return [new CreateUserSuccess()]
          }),
          catchError((err, caught) => {
            return of(new CreateUserFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  UpdateUser$ = createEffect(() =>
    this.actions.pipe(
      ofType(UsersTypes.UPDATE_USER_REQUEST),
      switchMap((action: UpdateUserRequest) => {
        return this.usersService.updateUser(action.id, action.payload).pipe(
          switchMap((result) => {
            this.router.navigate(['/admin/users'])
            return [
              new FetchUserRequest(action.id, 'updateUser'),
              new UpdateUserSuccess(),
            ]
          }),
          catchError((err, caught) => {
            return of(new UpdateUserFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  UpdateUserPassword$ = createEffect(() =>
    this.actions.pipe(
      ofType(UsersTypes.UPDATE_USER_PASSWORD_REQUEST),
      switchMap((action: UpdateUserPasswordRequest) => {
        return this.usersService
          .updateUserPassword(action.id, action.payload)
          .pipe(
            switchMap((result) => {
              this.router.navigate(['/admin/users'])
              return [new UpdateUserPasswordSuccess()]
            }),
            catchError((err, caught) => {
              return of(new UpdateUserPasswordFailure({ error: err }))
            }),
          )
      }),
    ),
  )
}
